import FileVO from "../../../ts/common/FileVO";
import React from "react";
import moment from "moment/moment";
import {phpToMomentDateFormat} from "../../../ts/common/SiteHelper";
import AppButton from "../../element/button/AppButton";

interface IProps
{
    fileVO: FileVO;
}
const CardDownloadView = (props: IProps) =>
{
    const item = props.fileVO
    return <div className="card downloads-cards with-link">
        <div className="card-body">

            <h2 className={"card-title "+((item.title.length > 32) ? 'reduced' : '')}>
                {item.title.length > 120 ? item.title.substring(0, 120)  + '...' : item.title}
            </h2>

            <ul className="vertical-icons no-icon">

                <li><strong>Published:</strong> {item.date ? moment(item.date).format(phpToMomentDateFormat('jS M Y')) : ""}</li>

                <li><strong>File Type:</strong>

                    {item.icon && <>
                        <span className={"is-fa "+item.icon} aria-hidden="true"></span>
                    </>}
                    {item.extension && <>
                        <span className="visually-hidden">{item.extension.toUpperCase()}</span>
                    </>}
                </li>

                {item.friendlySize && <>
                    <li><strong>Size:</strong> {item.friendlySize}</li>
                </>}
            </ul>

        </div>
        <AppButton
            className="stretched-link"
            data-file-download-name={item.title}
            data-file-download-path={item.url}
            title={item.title}
            href={item.url}
            rel="noopener"
        ></AppButton>

    </div>
}
export default CardDownloadView;